import { Component, computed, effect, viewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { FolderNoteStore } from './folder-note.store';
import { fb } from '../../../../shared/shared.global-service';
import { isInvalid } from '../../../../shared/helpers/validate';
import { contentGlobalSuccess } from '../../../content.error';
import { FilterBuilder } from '../../../helper/filter.builder';
import { getNotesFrag } from './folder-note.query';
import { FolderNoteGridItemObject } from '@libs/types/src/services/object-type/folder/folder-note.object';
import { InputWysiwygComponent } from '../../../../shared/components/inputs/input-wysiwyg/input-wysiwyg.component';

import { SafeHtmlPipe } from '@openng/optimus-ui/menu';
import { ActionButtonsComponent } from '../../../../../components/kit/action-buttons/action-buttons.component';

@Component({
    selector: 'app-folder-note',
    templateUrl: './folder-note.component.html',
    styleUrls: ['./folder-note.component.scss'],
    providers: [FolderNoteStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    SafeHtmlPipe,
    InputWysiwygComponent,
    ActionButtonsComponent
],
})
export class FolderNoteComponent {
    protected readonly store = inject(FolderNoteStore);


    public readonly wysiwyg = viewChild<InputWysiwygComponent>(InputWysiwygComponent);

    protected edit = false;
    protected form = fb.group({
        note: fb.control(''),
    });

    protected sharingFoldersNotes = computed(() => {
        const services = this.store.globalGlobalStore.organizationStore.allServices();
        const notes: any[] = (this.store.data.getFolderNotes()?.items || [])
            .filter((it: FolderNoteGridItemObject) => it.folder.serviceId != this.store.globalGlobalStore.loggedUserStore.selectedServiceId())
            .map((it: FolderNoteGridItemObject) => {
                return {
                    note: it.note,
                    serviceId: it.folder.serviceId,
                    serviceName: services?.find((ij) => ij.id == it.folder.serviceId)?.name || '',
                };
            })
        ;

        return notes.filter((it: any, index: number) => {
            return notes.findIndex((ij) => ij.serviceId === it.serviceId) === index;
        });
    });

    constructor() {
        effect(() => {
            this.getNotes();
        });
    }

    public toggleEdit() {
        if (!this.store.isAllowed('folderNote.create')()) return;
        this.edit = !this.edit;
    }

    protected async save() {
        if (!this.store.isAllowed('folderNote.create')()) return;
        const folderId = this.store.folderId();
        if (isInvalid(this.form) || !folderId) return;
        if (this.form.value.note == '') return;
        await this.store.api.createFolderNote({ note: this.form.value.note || '', folderId });
        this.edit = false;

        this.wysiwyg()?.resetBackupValues();
        contentGlobalSuccess.next('common.updated');
        this.getNotes();
    }

    private async getNotes(): Promise<void> {
        if (!this.store.isAllowed('folderNote.read')()) return;
        const folderId = this.store.folderId();
        if (!folderId) return;

        const res = await this.store.api.getFolderNotes(
            FilterBuilder.singlePage({
                folderId,
                sort: { column: 'date', direction: 'DESC' },
            }),
            getNotesFrag);
        const note = res?.items?.find((it: FolderNoteGridItemObject) => it.folder.serviceId == this.store.globalGlobalStore.loggedUserStore.selectedServiceId());
        if (note) {
            this.form.patchValue({ note: note.note });
        }
    }
}
